<template>
  <video-player  class="video-player-box"
                 ref="videoPlayer"
                 :options="playerOptions"
                 :playsinline="true"
                 customEventName="customstatechangedeventname"

                 @play="onPlayerPlay($event)"
                 @pause="onPlayerPause($event)"
                 @ended="onPlayerEnded($event)"
                 @waiting="onPlayerWaiting($event)"
                 @playing="onPlayerPlaying($event)"
                 @loadeddata="onPlayerLoadeddata($event)"
                 @timeupdate="onPlayerTimeupdate($event)"
                 @canplay="onPlayerCanplay($event)"
                 @canplaythrough="onPlayerCanplaythrough($event)"

                 @statechanged="playerStateChanged($event)"
                 @ready="playerReadied">
  </video-player>
</template>

<script>
// require styles
import 'video.js/dist/video-js.css'

import { videoPlayer } from 'vue-video-player'

export default {
  components: {
    videoPlayer
  },
  props: ["source"],
  data() {
    return {
      shadowSource: this.source,
      playerOptions: {
        // videojs options
        muted: false,
        fluid: true,
        language: 'en',
        height: 600,
        aspectRatio: '16:9',
        preload: 'metadata',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: this.source
        }],
        poster: "/static/images/author.jpg"
      }
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    pausePlayer() {
      if (this.player !== 'undefined') {
        console.log("pausing player ", this.player)
        this.player.pause()
      }
    },
    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    onPlayerEnded(player) {
      // console.log('player pause!', player)
    },
    onPlayerWaiting(player) {

    },
    onPlayerPlaying(player) {

    },
    onPlayerLoadeddata(player) {

    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
    onPlayerTimeupdate(playerTime) {

    },

    // player is ready
    onPlayerCanplay(player) {
      // console.log('the player can play', player)
      // you can use it to do something...
      // player.[methods]
    },
    onPlayerCanplaythrough(player) {
      // console.log('the player can play through', player)
      // you can use it to do something...
      // player.[methods]
    },
    playerReadied(player) {
      // console.log('the player is readied', player)
      // you can use it to do something...
      // player.[methods]
    }
  },
  mounted() {
    console.log('this is current player instance object', this.player)
  }
}
</script>
